/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const CountryCodeFormatter = (cellContent, row, rowIndex) => {
  const { country_code } = row;
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {country_code ? country_code : "-"}
      </div>
      <> </>
    </>
  );
};
